export default "__VITE_ASSET__Co0UDQZ5__";